import { render } from "./ClaimAccount.vue?vue&type=template&id=67e7946c"
import script from "./ClaimAccount.vue?vue&type=script&lang=js"
export * from "./ClaimAccount.vue?vue&type=script&lang=js"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__